export class Message {
    id: number;
    category: string;
    target_type: string;
    target_id: number;
    title: string;
    body: string;
    data: {
        reservation_swap_id?: number;
        target?: string;
    };
    created_at: string;
}

export const enum MessageCategory {
    SWAP_REQUEST_MEMBER    = 'swap-request-member',
    SWAP_REQUEST_ALL       = 'swap-request-all',
    SWAP_REQUEST_RESPONSE  = 'swap-request-response',
    SWAP_REQUEST_CONFIRMED = 'swap-request-confirmed',
}
